import firebase from 'firebase'

import Vue from 'vue'
import Router from 'vue-router'
//import Auth from '@okta/okta-vue'
//import auth0 from 'auth0-js'

import Home from '@/views/Home'
import About from '@/views/About'
import AllModules from '@/views/AllModules'
import Login from '@/views/Login'
import Register from '@/views/Register'
import Admin from '@/views/Admin'
import LessonBuilder from '@/views/LessonBuilder'
import UserDash from '@/views/UserDash'
import Module from '@/views/Module'
import MSSkills from '@/views/MSSkills'
import LessonTest from '@/views/LessonTest'
import Resources from '@/views/Resources'
import KMData from '@/views/KMData'
import SkillsData from '@/views/SkillsData'
import ClientKnowledge from '@/views/ClientKnowledge'
import Quiz from '@/views/Quiz'
import Lesson from '@/views/Lesson'
import Score from '@/views/Score'
import Meta from 'vue-meta'
import ProjectStaffings from '@/views/ProjectStaffings'
import TalentQuiz from '@/views/TalentQuiz'
import InnovationUpload from '@/views/InnovationUpload'

//const production = true;

//const CALLBACK_PATH = '/app/hbrconsulting_hbrcompetencies_1/exk7skeb51Ya1yM5s2p7/sso/saml'

// ----- HBR Okta Config -----

/*const config = {
  clientId: 'exk7skeb51Ya1yM5s2p7',
  issuer: 'https://www.okta.com/exk7skeb51Ya1yM5s2p7',
  redirect_uri: 'https://hbrconsulting.okta.com/app/hbrconsulting_hbrcompetencies_1/exk7skeb51Ya1yM5s2p7/sso/saml',
  scopes: 'openid profile email',
  pkce: true
}*/

// ----- Personal Okta Config -----

/*const config = {
  clientId: '0oaegy7l0AL6YJ4VF4x6',
  issuer: 'https://dev-347385.okta.com/oauth2/default',
  redirect_uri: 'https://hbrc-18a6e.web.app/implicit/callback',
  scopes: ['openid','profile','email'],
  pkce: true
}*/

// ----- SAML config -----

/*const config = {
  issuer: 'http://www.okta.com/exkkz8ybgL2CD8tQC4x6',
  redirect_uri: 'https://dev-347385.okta.com/app/brewdev347385_hbrc_1/exkkz8ybgL2CD8tQC4x6/sso/saml',
}*/

Vue.use(Router)
Vue.use(Meta);
//Vue.use(auth0)

Vue.use(Meta, {
  keyName: 'viewport',
  attribute: 'content',
  ssrAttribute: 'width=device-width,initial-scale=0.67',
})

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/talent-quiz',
      name: 'TalentQuiz',
      component: TalentQuiz,
    },
    {
      path: '/',
      name: 'home',
      component: Home,
      meta: {

      }
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      meta: {
        //guest: true
        requiresAuth: false
      }
    },

    {
      path: '/resources',
      name: 'resources',
      component: Resources,
      meta: {
        //auth: true
        requiresAuth: true
      }
    },

    {
      path: '/knowledge_management',
      name: 'km_data',
      component: KMData,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/client_knowledge',
      name: 'client_knowledge',
      component: ClientKnowledge,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/skills_data',
      name: 'skills_data',
      component: SkillsData,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/ms_skills',
      name: 'ms_skills',
      component: MSSkills,
      meta: {
        requiresAuth: true
      }
    },

    {
      path:'/project_staffings',
      name:'project_staffings',
      component: ProjectStaffings,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/counsel_command',
      name: 'lesson_test',
      component: LessonTest,
      meta: {
        //guest: true
        requiresAuth: true
      }
    },
    {
      path: '/all_modules',
      name: 'AllModules',
      component: AllModules,
      meta: {
        //auth: true
        requiresAuth: true
      },
      children: [
        {
          path: ':current',
          name: 'module',
          component: Module
        }
      ]
    },

    {
      path: '/register',
      name: 'register',
      component: Register,
      meta: {
        //guest: true
        requiresAuth: false
      }
    },
    {
      path: '/auth',
      name: 'login',
      component: Login,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        //auth: true
        requiresAuth: true
      }
    },

    {
      path: '/lesson_builder',
      name: 'lesson_builder',
      component: LessonBuilder,
      meta: {
        //auth: true
        requiresAuth: true
      }
    },

    {
      path: '/dashboard',
      name: 'dashboard',
      component: UserDash,
      meta: {
        //auth: true
        requiresAuth: true
      }
    },

    {
      path: '/lesson/:current',
      name: 'lesson',
      component: Lesson,
      meta: {
        //auth: true
        requiresAuth: true
      }
    },

    {
      path: '/quiz/:current',
      name: 'quiz',
      component: Quiz,
      meta: {
        //auth: true
        requiresAuth: true
      }
    },

    {
      path: '/score/:current',
      name: 'score',
      component: Score,
      meta: {
        //auth: true
        requiresAuth: true
      }
    },

    {
      path: '/innovation-deck-upload',
      name: 'InnovationUpload',
      component: InnovationUpload,
      meta: {
        //auth: true
        requiresAuth: true
      }
    }
  ],
})

//----------routing guards----------

import store from '../store';

router.beforeEach((to, from, next) => {

  console.log('redirect result exists?: ', firebase.auth().getRedirectResult());

  firebase.auth().onAuthStateChanged((userAuth) => {
    if(userAuth) {
      console.log('user exists after auth state change?:', userAuth);
      store.commit('updateUser', userAuth);
      console.log('userAuth: ', userAuth);
      if(to.path == 'auth' || to.path == '/register' || to.path == '/') {
        return next('/dashboard');
      }
    } else {
      return next('/auth');
    }
  })

  console.log('guard route');
  console.log('to: ', to, 'from: ', from);

  /*next({
    path: '/login'
  })*/

  //to = '/login';

  next();

})

//router.beforeEach(Vue.prototype.$auth.authRedirectGuard())

export default router
